module.exports = __webpack_public_path__ + "img/line_maw.de5592cf.png";